import React from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-col">
          <h4>Navigation</h4>
          <nav>
            <ul>
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">À propos</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <address>
            <p>Email : <a href="mailto:contact@dctp.fr">contact@dctp.fr</a></p>
            <p>Tél : <a href="tel:+33615858522">06 15 85 85 22</a></p>
            <p>Zone : Occitanie & Nouvelle-Aquitaine</p>
          </address>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} DCTP – VRD & Géothermie. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
